import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import SearchLensIcon from "@components/Icons/SearchLensIcon";
import SearchSelect from "@components/SearchSelect";
import "./style.scss";

const Venues = ({ handleVenueClick, selectedVenue, venueList }) => {
    const { closeDrawer } = useContext(AuthContext);

    const filterOptions = (candidate, input) => {
        if (!candidate.value || typeof candidate.value !== "string") {
            return false;
        }

        const candidateStr = candidate.value.toLowerCase();
        const candidateTerms = candidateStr.split(" ");
        const searchStr = input.toLowerCase();

        return searchStr && searchStr.includes(" ")
            ? candidateStr.includes(searchStr)
            : searchStr
                ? candidateTerms.some((str) => str.startsWith(searchStr))
                : false;
    };

    const handleOnChangeVenue = (option, { action }) => {
        if (action === "clear") {
            handleVenueClick("");
        } else if (action === "select-option") {
            closeDrawer("venuesDrawer");
            handleVenueClick(option.label);
        }
    };

    const customNoOptionsMessage = () => (
        <span className="venue-finder__no-results">
            We did not find any venues
        </span>
    );

    const selectedVenueOption = venueList.find(
        (item) => item.value.toLowerCase() === selectedVenue?.toLowerCase(),
    );

    return (
        <>
            <div className="venue-finder">
                <h2 className="venue-finder__title">Find a cinema</h2>
                <div className="venue-finder__input-wrapper">
                    <span className="venue-finder__search-icon">
                        <SearchLensIcon className="venue-finder__search-svg" />
                    </span>
                    <SearchSelect
                        placeholder="Search by cinema"
                        aria-label="Search by cinema"
                        value={selectedVenueOption}
                        options={venueList}
                        filterOption={filterOptions}
                        onChange={handleOnChangeVenue}
                        isClearable={true}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        openMenuOnClick={false}
                        noOptionsMessage={customNoOptionsMessage}
                    />
                </div>
            </div>
        </>
    );
};

export default Venues;
